import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../_services';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // add authorization header with basic auth credentials if available
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser && currentUser.token) {
      if(request.url.endsWith('upload')){
        request = request.clone({
          setHeaders: {
            'x-auth-token': currentUser.token
          }
        });
      }else{
        request = request.clone({
          setHeaders: {
            'x-auth-token': currentUser.token,
            'content-type': 'application/json'
          }
        });
      }
    }

    return next.handle(request);
  }
}
